import onReady from '@/scripts/modules/on-ready';

onReady( () => {
	const programStatus = document.querySelector( '.program-status select' );
	const programs = document.querySelectorAll( '.program-programs option' );

	programStatus.addEventListener( 'change', function () {
		programs.forEach( ( option ) => {
			if (
				typeof window.theme.status_availability[ option.value ] !==
					'undefined' &&
				window.theme.status_availability[ option.value ].indexOf(
					programStatus.value
				) !== -1
			) {
				option.disabled = false;
			} else {
				option.disabled = true;
			}
		} );
	} );
} );
